module.exports = __webpack_public_path__ + "static/media/projectsImage1.f8fba357.jpg";